"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
var preact_1 = require("preact");
var typescript_parsec_1 = require("typescript-parsec");
var color_1 = require("./common/color");
// Link to docs: https://github.com/microsoft/ts-parsec/blob/master/doc/ParserCombinators.md
var TokenKind;
(function (TokenKind) {
    // Character tokens
    TokenKind[TokenKind["LParen"] = 0] = "LParen";
    TokenKind[TokenKind["RParen"] = 1] = "RParen";
    TokenKind[TokenKind["LBrace"] = 2] = "LBrace";
    TokenKind[TokenKind["RBrace"] = 3] = "RBrace";
    TokenKind[TokenKind["Char"] = 4] = "Char";
    // Pattern tokens
    TokenKind[TokenKind["Bold"] = 5] = "Bold";
    TokenKind[TokenKind["Italic"] = 6] = "Italic";
    TokenKind[TokenKind["Link"] = 7] = "Link";
    TokenKind[TokenKind["Break"] = 8] = "Break";
    TokenKind[TokenKind["Color"] = 9] = "Color";
})(TokenKind || (TokenKind = {}));
var tokenizer = (0, typescript_parsec_1.buildLexer)([
    // Character tokens
    [true, /^\(\(/g, TokenKind.LParen],
    [true, /^\)\)/g, TokenKind.RParen],
    [true, /^\{\{/g, TokenKind.LBrace],
    [true, /^\}\}/g, TokenKind.RBrace],
    [true, /^./g, TokenKind.Char],
    // Pattern tokens
    [true, /^\[bold\]/g, TokenKind.Bold],
    [true, /^\[italic\]/g, TokenKind.Italic],
    [true, /^\[link\]/g, TokenKind.Link],
    [true, /^\[br\]/g, TokenKind.Break],
    [true, /^\[color\]/g, TokenKind.Color],
    [true, /^\[image\]/g, TokenKind.Color],
]);
// Base parser. declared first to use recursively
var parser = (0, typescript_parsec_1.rule)();
// Parse character token to character
var charParser = (0, typescript_parsec_1.apply)((0, typescript_parsec_1.tok)(TokenKind.Char), function (token) {
    return token.text;
});
// Parse a list of characters to string
var textParser = (0, typescript_parsec_1.apply)((0, typescript_parsec_1.rep_sc)(charParser), function (charList) {
    return charList.join('');
});
// Parse [bold]((xxx)) to <b>xxx</b>
var boldParser = (0, typescript_parsec_1.kmid)((0, typescript_parsec_1.seq)((0, typescript_parsec_1.str)('[bold]'), (0, typescript_parsec_1.str)('((')), (0, typescript_parsec_1.apply)(parser, function (text) { return (0, preact_1.h)("b", null, text); }), (0, typescript_parsec_1.str)('))'));
// Parse [image]((link)) to <img src={link} alt="" />
var imageParser = (0, typescript_parsec_1.kmid)((0, typescript_parsec_1.seq)((0, typescript_parsec_1.str)('[image]'), (0, typescript_parsec_1.str)('((')), (0, typescript_parsec_1.apply)(textParser, function (text) { return (0, preact_1.h)("img", { src: text, alt: "" }); }), (0, typescript_parsec_1.str)('))'));
// Parse [italic]((xxx)) to <i>xxx</i>
var italicParser = (0, typescript_parsec_1.kmid)((0, typescript_parsec_1.seq)((0, typescript_parsec_1.str)('[italic]'), (0, typescript_parsec_1.str)('((')), (0, typescript_parsec_1.apply)(parser, function (text) { return (0, preact_1.h)("i", null, text); }), (0, typescript_parsec_1.str)('))'));
// Parse [color]((FLO PMS Relief)){{flo-pms-pink}}
// to <b style="color: #C41423">FLO PMS Relief</b>
var colorParser = (0, typescript_parsec_1.apply)((0, typescript_parsec_1.kright)((0, typescript_parsec_1.str)('[color]'), (0, typescript_parsec_1.seq)((0, typescript_parsec_1.kmid)((0, typescript_parsec_1.str)('(('), parser, (0, typescript_parsec_1.str)('))')), (0, typescript_parsec_1.kmid)((0, typescript_parsec_1.str)('{{'), textParser, (0, typescript_parsec_1.str)('}}')))), function (_a) {
    var text = _a[0], color = _a[1];
    var hex = (0, color_1.toHex)(color === null || color === void 0 ? void 0 : color.toString());
    return (0, preact_1.h)("b", { style: "color:".concat(hex) }, text);
});
// Parse [link]((shop now)){{https://yyy.com}}
// to <a href="https://yyy.com">shop now</a>
var linkParser = (0, typescript_parsec_1.apply)((0, typescript_parsec_1.kright)((0, typescript_parsec_1.str)('[link]'), (0, typescript_parsec_1.seq)((0, typescript_parsec_1.kmid)((0, typescript_parsec_1.str)('(('), parser, (0, typescript_parsec_1.str)('))')), (0, typescript_parsec_1.kmid)((0, typescript_parsec_1.str)('{{'), textParser, (0, typescript_parsec_1.str)('}}')))), function (_a) {
    var text = _a[0], url = _a[1];
    return (0, preact_1.h)("a", { href: url }, text);
});
/**
 * Parse fn for line break
 * [br] -> <br/>
 * [br]{{mobile}} -> <br class='hide-on-desktop' />
 * [br]{{desktop}} -> <br class='hide-on-mobile' />
 */
var breakParser = (0, typescript_parsec_1.alt_sc)((0, typescript_parsec_1.kmid)((0, typescript_parsec_1.seq)((0, typescript_parsec_1.str)('[br]'), (0, typescript_parsec_1.str)('{{')), (0, typescript_parsec_1.apply)(textParser, function (text) {
    switch (text) {
        case 'mobile':
            return (0, preact_1.h)("br", { class: "hide-on-desktop" });
        case 'desktop':
            return (0, preact_1.h)("br", { class: "hide-on-mobile" });
        default:
            return (0, preact_1.h)("br", null);
    }
}), (0, typescript_parsec_1.str)('}}')), (0, typescript_parsec_1.apply)((0, typescript_parsec_1.str)('[br]'), function () { return (0, preact_1.h)("br", null); }));
// Set pattern for the base parser
parser.setPattern((0, typescript_parsec_1.rep_sc)((0, typescript_parsec_1.alt)(boldParser, italicParser, linkParser, breakParser, colorParser, textParser, imageParser)));
var parse = function (input) {
    try {
        return (0, typescript_parsec_1.expectSingleResult)((0, typescript_parsec_1.expectEOF)(parser.parse(tokenizer.parse(input))));
    }
    catch (error) {
        console.log(error);
        return input;
    }
};
exports.parse = parse;
